// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Dropzone_dropzone__STyD8"};